import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'orders.form.executionEvents.dynamicLoadsCf.loads' }),
    undeclared: translate({ id: 'orders.form.executionEvents.dynamicLoadsCf.undeclared' }),
  }))

  return api
}
